
import * as __star__ from 'ckeditor5';

const {

Bold,
ClassicEditor,
EditorConfig,
Essentials,
GeneralHtmlSupport,
Italic,
Paragraph,
Underline
} = __star__;

export {
Bold,
ClassicEditor,
EditorConfig,
Essentials,
GeneralHtmlSupport,
Italic,
Paragraph,
Underline
};

